<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex flex-column">
        <div class="fs-4">
          {{ 'instagramAccount.connectedInstagramAccounts' | transloco }}
        </div>
        <div class="text-muted">
          {{ 'instagramAccount.connectedAccountsDescription' | transloco }}
        </div>
      </div>
      <div>
        <button pButton type="button" class="instagram instagram-buttob-border ms-1 p-button-lg fw-bold "
          (click)="onConnectInstagramAccount()"><i class="pi pi-instagram me-2"></i>{{ 'instagramAccount.connectInstagram' | transloco }}
        </button>
        <!-- <button *ngIf="instagramAccount.length !== 0" pButton type="button" class="instagram instagram-buttob-border ms-1 p-button-lg fw-bold "
        (click)="deleteAllCaaounts()"><i class="pi pi-instagram me-2"></i>Delete All Accounts
      </button> -->
    </div>

  </div>
  <hr />
  <!-- Instagram Accounts as Cards -->
  <div class="row d-flex ">
    @for (account of instagramAccount; track account) {
      <div class="col-md-4 col-sm-6 mb-4">
        <div class="card shadow rounded-3 overflow-hidden">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <img [src]="account.UserProfilePictureUrl" class="rounded-circle me-3" width="70"
                height="70" />
                <div class="d-flex justify-content-between w-100">
                  <div class="d-flex flex-column">
                    <div class="fs-4 fw-semibold text-dark">{{ account.UserName }}</div>
                    @if (account.IsActive) {
                      <div class="badge bg-success text-white mt-2">{{ 'instagramAccount.active' | transloco }}</div>
                    }
                    @if (!account.IsActive) {
                      <div class="badge bg-warning text-dark mt-2">{{ 'instagramAccount.notActive' | transloco }}
                      </div>
                    }
                  </div>
                  <div>
                    <button class="btn btn-outline-warning btn-sm "
                      (click)="onDeactivateInstagramAccount(account.Id)"
                      [pTooltip]="'instagramAccount.deactivateTooltip' | transloco" tooltipPosition="top">
                      {{ 'instagramAccount.deactivate' | transloco }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column ">
                <div class="d-flex align-items-center">
                  <i class="pi pi-users me-2"></i>
                  <div class="fs-6 text-muted">{{ 'instagramAccount.followers' | transloco }} </div>
                  <div class="fs-6 text-dark"> {{ account.followers_count }}</div>
                </div>
                <div class="d-flex align-items-center">
                  <i class="pi pi-users me-2"></i>
                  <div class="fs-6 text-muted">{{ 'instagramAccount.follows' | transloco }} </div>
                  <div class="fs-6 text-dark ms-1">{{ account.follows_count }}</div>
                </div>
                <div class="d-flex align-items-center">
                  <i class="fa fa-file-image-o me-2"></i>
                  <div class="fs-6 text-muted">{{ 'instagramAccount.media' | transloco }} </div>
                  <div class="fs-6 text-dark ms-1">{{ account.media_count }}</div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="fs-6 text-muted">{{ 'instagramAccount.connectedAt' | transloco }} </div>
                <div class="fs-6 text-dark ms-1"> {{ account.ConnectedAt | date: 'dd/MM/yyyy HH:mm' }}</div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <!-- No Accounts Found -->
    @if (!instagramAccount || instagramAccount.length === 0) {
      <div class="text-center text-muted mt-3">
        {{ 'instagramAccount.noAccountsFound' | transloco }}
      </div>
    }
  </div>
</div>